import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HeadProvider } from 'react-head';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Stagewise toolbar
// import { StagewiseToolbar } from '@stagewise/toolbar-react';
// import { ReactPlugin } from '@stagewise-plugins/react';

// Context providers
import { AuthProvider } from '../context/AuthContext';
import { LanguageProvider } from '../context/LanguageContext';
import { ThemeProvider } from '../context/ThemeContext';
import { NotificationProvider } from '../context/NotificationContext';
import { OnboardingProvider } from '../context/OnboardingContext';
import { FiltersProvider } from '../context/FiltersContext';

// UI providers
import { ModernThemeProvider } from '../components/UIKit';

// Redux store
import store from '../redux/store';

// Services
import libraryEventsService from '../services/libraryEventsService';

// Initialize services
libraryEventsService.init(store.dispatch);

/**
 * Централізована конфігурація всіх провайдерів додатку
 * Порядок провайдерів важливий - зовнішні провайдери повинні обгортати внутрішні
 */
export const AppProviders = ({ children }) => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AuthProvider>
            <LanguageProvider>
              <HeadProvider>
                <ThemeProvider>
                  <ModernThemeProvider>
                    <OnboardingProvider>
                      <NotificationProvider>
                        <FiltersProvider>
                          {/* <StagewiseToolbar config={{ plugins: [ReactPlugin] }} /> */}
                          {children}
                          <ToastContainer position="top-right" autoClose={3000} />
                        </FiltersProvider>
                      </NotificationProvider>
                    </OnboardingProvider>
                  </ModernThemeProvider>
                </ThemeProvider>
              </HeadProvider>
            </LanguageProvider>
          </AuthProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
};

export default AppProviders;
